module.exports = __webpack_public_path__ + "img/edmbet-support.838634c1.png";